import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  X_API_KEY = environment.xApiKey;

  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes(environment.s3BasePath)) return next.handle(req);
 
    const authToken = this.authService.getToken();
    const authRequest = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + authToken,
        'x-api-key': this.X_API_KEY
      }
    });

    return next.handle(authRequest);
  }
}
